const LEJOS = 'lejos';
const CERCA = 'cerca';
const INTERMEDIO = 'intermedio';

export {LEJOS, CERCA, INTERMEDIO}